function HouseTypes({
  selectedCategory,
  setSelectedType,
  goBack
}) {
  const residentialTypes = [
    "Single Room",
    "Bedsitter",
    "Double Room",
    "1 Bedroom Apartment",
    "2 Bedroom Apartment",
    "3 Bedroom Apartment",
    "2 Bedroom Mansionette",
    "3 Bedroom Mansionette",
    "3 Bedroom Bungalow"
  ];

  const commercialTypes = [
    "Office Space",
    "Shop",
    "Warehouse",
    "Business Premises",
    "Commercial Building",
    "Coworking Space"
  ];

  const propertyTypes =
    selectedCategory === "Commercial"
      ? commercialTypes
      : residentialTypes;

  const pageStyle = {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#000000,#1a1a1a,#ffd600)",
    padding: "40px 20px"
  };

  const containerStyle = {
    maxWidth: "1050px",
    margin: "auto"
  };

  const cardStyle = {
    background: "white",
    borderRadius: "25px",
    padding: "40px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    textAlign: "center"
  };

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "20px",
    marginTop: "30px"
  };

  const typeButton = {
    background: "#ffd600",
    color: "#000",
    border: "none",
    padding: "18px",
    borderRadius: "15px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
    transition: "0.2s ease",
    minHeight: "70px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center"
  };

  const backButton = {
    padding: "12px 20px",
    border: "none",
    borderRadius: "10px",
    fontWeight: "bold",
    cursor: "pointer",
    marginBottom: "20px"
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>

        {/* BACK */}
        <button style={backButton} onClick={goBack}>
          ⬅ Back
        </button>

        {/* MAIN CARD */}
        <div style={cardStyle}>
          <h1 style={{ marginBottom: "10px" }}>
            🏘️ Choose Property Type
          </h1>

          <p style={{ color: "#666", marginBottom: "25px" }}>
            {selectedCategory} Properties
          </p>

          {/* GRID */}
          <div style={gridStyle}>
            {propertyTypes.map((type) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                style={typeButton}
                onMouseOver={(e) =>
                  (e.target.style.transform = "scale(1.03)")
                }
                onMouseOut={(e) =>
                  (e.target.style.transform = "scale(1)")
                }
              >
                {selectedCategory === "Commercial" ? "🏢 " : "🏠 "}
                {type}
              </button>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

export default HouseTypes;